import { Box, IconButton, Typography } from "@mui/material";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import MailOutlineIcon from "@mui/icons-material/MailOutline";

const Footer = () => {
  return (
    <Box
      sx={{
        mt: 6, // margin-top to separate from content above
        textAlign: "center", // center the text
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between", // space between left and right content
      }}
    >
      <Typography variant="h4">© 2026 William Jiang</Typography>

      <Box display="flex">
        <IconButton href="https://github.com/williamjiang26">
          <GitHubIcon fontSize="medium" />
        </IconButton>
        <IconButton
          href="https://www.linkedin.com/in/williamjiang26/"
          aria-label=""
        >
          <LinkedInIcon fontSize="medium" />
        </IconButton>
        <IconButton href="mailto:william.jiang1122@gmail.com" aria-label="">
          <MailOutlineIcon fontSize="medium" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Footer;
